import { uiSlice } from '../../slices/uiSlice'
import {
  setDeviceType,
  setDeviceWidth,
} from '@wellesley/host-remote/api/actions'
import { getDeviceType } from '../../helpers/device'
import { useResize } from 'hooks/useResize'
import { useDispatch, useSelector } from 'react-redux'

export const useDeviceTypeUpdater = () => {
  const dispatch = useDispatch()

  const onResize = () => {
    const deviceType = getDeviceType()
    dispatch(setDeviceType(deviceType))
    dispatch(setDeviceWidth(window.innerWidth))
  }

  useResize(onResize)
}

export const useDeviceType = () =>
  useSelector(uiSlice.selectors.selectDeviceType)
export const useIsMobile = () => useSelector(uiSlice.selectors.selectIsMobile)
export const useIsTablet = () => useSelector(uiSlice.selectors.selectIsTablet)
export const useIsDesktop = () => useSelector(uiSlice.selectors.selectIsDesktop)
